import { render, staticRenderFns } from "./TilesSection.vue?vue&type=template&id=950cb260&scoped=true&"
import script from "./TilesSection.vue?vue&type=script&lang=js&"
export * from "./TilesSection.vue?vue&type=script&lang=js&"
import style0 from "./TilesSection.vue?vue&type=style&index=0&id=950cb260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950cb260",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
